import { Prefs } from "../../alias/prefs";
const statsStorageKey = "onpage_dialog_command_stats";
export function clearStats(dialogId) {
    const statsStorage = Prefs.get(statsStorageKey);
    delete statsStorage[dialogId];
    void Prefs.set(statsStorageKey, statsStorage);
}
export function getStats(dialogId) {
    const storage = Prefs.get(statsStorageKey);
    const storedStats = storage[dialogId];
    if (isStats(storedStats)) {
        return storedStats;
    }
    const initialStats = {
        displayCount: 0,
        lastDisplayTime: 0,
    };
    setStats(dialogId, initialStats);
    return initialStats;
}
export function isStats(candidate) {
    return (candidate !== null &&
        typeof candidate === "object" &&
        "displayCount" in candidate &&
        "lastDisplayTime" in candidate);
}
export function setStats(dialogId, stats) {
    const storage = Prefs.get(statsStorageKey);
    storage[dialogId] = stats;
    void Prefs.set(statsStorageKey, storage);
}
